import { render, staticRenderFns } from "./apv-view-dialog.vue?vue&type=template&id=99bd5324&v-if=promotion.length%20%3E%200&"
import script from "./apv-view-dialog.vue?vue&type=script&lang=js&"
export * from "./apv-view-dialog.vue?vue&type=script&lang=js&"
import style0 from "./apv-view-dialog.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports